import { useEffect, useRef } from "react";

// Koçum ekranlarının bağlantı dayanıklılığı (saha, 25 Eyl 2026): öğrenci AI öğretmendeyken internet koptu;
// arka plandaki yenileme düşünce Bugün ekranı kırmızı hata kutusunda kalıyor, internet gelse de geçmiyordu.

// Tarayıcılar kopuşu farklı adlandırır: Chrome "Failed to fetch", Safari "Load failed", Firefox "NetworkError…".
export const isNetworkError = (e: unknown): boolean =>
  (typeof navigator !== "undefined" && navigator.onLine === false) ||
  /failed to fetch|load failed|networkerror|network request failed/i.test(String((e as any)?.message || ""));

export const coachErrorMessage = (e: unknown, fallback: string): string =>
  isNetworkError(e)
    ? "İnternet bağlantın kopmuş görünüyor. Bağlantı gelince kendiliğinden yenilenecek."
    : (e as any)?.message || fallback;

// Uygulamaya her dönüşte değil, en fazla bu sıklıkta tazele (Bugün isteği uzlaştırma da çalıştırır).
const VISIBLE_REFRESH_MS = 30_000;

// Liste ekranı kendini sessizce tazeler: bağlantı geri gelince, AI öğretmen paneli kapanınca, bir eksik
// giderilince ve uygulamaya dönülünce. AI penceresini açmak artık kalemi bitirmediği için kalemin sonucu
// panelden dönüşte görünür.
export function useCoachAutoRefresh(refresh: () => void) {
  const ref = useRef(refresh);
  useEffect(() => {
    ref.current = refresh;
  }, [refresh]);

  useEffect(() => {
    let lastRun = Date.now();
    const run = () => {
      lastRun = Date.now();
      ref.current();
    };
    const onVisible = () => {
      if (document.visibilityState === "visible" && Date.now() - lastRun > VISIBLE_REFRESH_MS) run();
    };
    const events = ["online", "aiTutorPanelClosed", "aiTeacherGainResolved"];
    events.forEach((name) => window.addEventListener(name, run));
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      events.forEach((name) => window.removeEventListener(name, run));
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
}
